// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class HistoricalBrokerMessageInfo {
    constructor() {
        this.ID = null;
        this.TimeStamp = null;
        this.ProductID = null;
        this.Subject = null;
        this.Message = null;
        this.IsUnread = null;
        this.ShowPopUp = null;
        this.ResponseCases = null;
        this.CustomButtons = null;
        this.ClusterNode = null;
        this.DisplayMethod = null;
    }
}
